export const ROW_GAP = 16;

export const rowProps = {
    space: 0,
    style: {
        flexWrap: 'wrap',
        gap: ROW_GAP,
    }
}